/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectConstants } from "./Api/constantSlice";
import { DropdownDto } from "./Api/Models";
import { ErrorBox } from "../custom/ErrorBox";
import { isEducationHdi, isFourthYearOfStudySelectable } from "../../features/applicant/pgdaConstants";

interface Props {
  formik: FormikProps<any>;
  isDisabled: boolean;
  label: string;
  removePGDA: boolean;
  /** When the form has no `institutionId` (e.g. Study Details step), pass education institution for option rules. */
  institutionIdOverride?: number;
}
export default function YearOfStudy({
  formik,
  isDisabled,
  label,
  removePGDA,
  institutionIdOverride,
}: Props) {
  const selConst = useAppSelector(selectConstants);

  const shouldDisable = (yearOfStudyId: number) => {
    if (removePGDA && yearOfStudyId === 5) {
      return true;
    }
    const institutionId =
      institutionIdOverride ?? formik.values.institutionId;
    const instNum = Number(institutionId);
    const instId = Number.isFinite(instNum) ? instNum : 0;
    if (
      (instId === 21 && yearOfStudyId === 1) ||
      (instId === 21 && yearOfStudyId === 2)
    ) {
      return true;
    }

    /** HDI (Venda, Zululand, Limpopo): all undergraduate / PGDA years remain selectable (subject to removePGDA). */
    if (isEducationHdi(institutionId)) {
      return false;
    }

    if (!isFourthYearOfStudySelectable(institutionId) && yearOfStudyId === 4) {
      return true;
    }

    // const matriculationYear = formik.values.matriculationYear;
    // const qualificationStartYear = formik.values.qualificationStartYear;
    // const currentYear = new Date().getFullYear();
    // if (
    //   (matriculationYear && matriculationYear === currentYear) ||
    //   qualificationStartYear === currentYear
    // ) {
    //   return true;
    // }

    return false;
  };

  const filteredList = () => {
    if (selConst.constantState) {
      return removePGDA
        ? selConst.constantState.yearOfStudies.filter((s) => s.id !== 5)
        : selConst.constantState.yearOfStudies;
    }
    return [];
  };
  return (
    <>
      {selConst.constantState.yearOfStudies && (
        <>
          <FormControl fullWidth disabled={isDisabled}>
            <InputLabel
              error={
                formik.touched.yearOfStudyId &&
                Boolean(formik.errors.yearOfStudyId)
              }
              id="demo-select-small"
            >
              {label}
            </InputLabel>
            <Select
              name="yearOfStudyId"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.yearOfStudyId}
              label={label}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.yearOfStudyId &&
                Boolean(formik.errors.yearOfStudyId)
              }
            >
              <MenuItem value={0} disabled>
                Select {label}
              </MenuItem>
              {filteredList().map((data: DropdownDto, key: number) => {
                return (
                  <MenuItem
                    key={key}
                    value={data.id}
                    disabled={shouldDisable(data.id)}
                  >
                    {data.description}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <ErrorBox>
            {formik.touched.yearOfStudyId &&
              (formik.errors.yearOfStudyId as React.ReactNode)}
          </ErrorBox>
        </>
      )}
    </>
  );
}
